import { render, staticRenderFns } from "./CreateRegistrant.vue?vue&type=template&id=abc9d2f8&scoped=true&"
import script from "./CreateRegistrant.vue?vue&type=script&lang=js&"
export * from "./CreateRegistrant.vue?vue&type=script&lang=js&"
import style0 from "./CreateRegistrant.vue?vue&type=style&index=0&id=abc9d2f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc9d2f8",
  null
  
)

export default component.exports